var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartHealthWellness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152,103.3H137.47L130,117.55a3.28,3.28,0,0,1-2.88,1.73h-.19a3.24,3.24,0,0,1-2.84-2.08l-9.94-26-9.54,25.5a3.27,3.27,0,0,1-3,2.11,3.2,3.2,0,0,1-3.07-2L87.35,90.54l-4.53,10.6a3.26,3.26,0,0,1-3,2H58.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.41,187.53a3.29,3.29,0,0,1-2.59-1.25c-11.32-14.54-23.46-26.4-34.17-36.86C49.29,127.58,30,108.72,30,77A39.53,39.53,0,0,1,69.9,38c18.8,0,31,16.3,38.49,26.85C115.86,54.27,128.1,38,146.9,38c15.17,0,24.62,7.17,29.88,13.18a40.49,40.49,0,0,1,10,25.84c0,31.74-19.32,50.6-41.68,72.45-10.71,10.45-22.84,22.31-34.16,36.84A3.25,3.25,0,0,1,108.41,187.53Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHealthWellness);
export default __webpack_public_path__ + "static/media/HEART_HEALTH_WELLNESS.8cdc3e560df43709ff16813b05c57fd4.svg";
export { ForwardRef as ReactComponent };